// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qZHkS","fullView":"styles_fullView__3Mthk"};